import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LocationIndividualService {
  private readonly _rolePrefix = 'individual';

  constructor(private _router: Router) {}

  private _routeToUrl(url: string, navigationData?: NavigationExtras) {
    this._router.navigate([url], navigationData).then();
  }

  routeToHomePage() {
    this._routeToUrl(`/${this._rolePrefix}`);
  }

  routeToNotifications() {
    this._routeToUrl(`/${this._rolePrefix}/notifications`);
  }

  routeToCreateAppointment() {
    this._routeToUrl(`/${this._rolePrefix}/appointments/create`);
  }

  routeToAppointments() {
    this._routeToUrl(`/${this._rolePrefix}/appointments`);
  }

  routeToCalendar() {
    this._routeToUrl(`/${this._rolePrefix}/calendar`);
  }

  routeToSettings() {
    this._routeToUrl(`/${this._rolePrefix}/settings`);
  }
}
